export const SupportedLanguage =
{
    enUS:"en-US",
    it:"it-IT" 
}